import React, {useState} from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import moment from "moment";
import { MdOutlineMoreHoriz } from "react-icons/md";
import { adminKiralikAracAprove } from "../../../features/admin3/admin3Slice";
import SmallSpinner from "../../shared/spinners/SmallSpinner";
import { setSelectRentalCar } from "../../../features/ilanlar/ilanlarSlice";
import { showModal } from "../../../features/modal/modalSlice";


const Container = styled.div`
  width: 100%;
  margin-block: 10px;
  background-color: ${({ theme }) => theme.secondaryBgColor};
  .container {
    width: 100%;

    .content {
      width: 100%;
      padding: 15px 10px;
      border-radius: 10px;
      margin: 10px 0px 0px 0px !important;
      position: relative;
      background-color: var(--color-light);
      .row {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(14, 1fr); 
        align-items: center;
        height: auto;
        .col {
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-md);
          text-align: center;
          gap: 10px;
          display: flex;
          flex-direction: column;
          p{
            border: 1px solid var(--color-main);
            padding: 5px;
            border-radius: 5px;
            color: var(--color-main);
            cursor: pointer;
          }
        }
      }
      .more{
        position: absolute;
        right: 10px;
        cursor: pointer;
        font-size: 20px;
      }
      .detail{
        position: absolute;
        top: 10px;
        right: 40px;
        background-color: white;
        padding: 10px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        gap: 5px;
        cursor: pointer;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        color: var(--color-main);
        
      }
    }
  }
`;

const AdminKiralikAracContainer = ({ data }) => {
  const { theme } = useSelector((state) => state.layout);
  const { isLoadingAdd } = useSelector((state) => state.admin3);
  const dispatch = useDispatch();
  const [isMoreActive, setIsMoreActive] = useState(null)

  const toggleMore = (item) => {
    if (isMoreActive === item) {
      setIsMoreActive(null);
    } else {
      setIsMoreActive(item);
    }
  };

  const handleAprove = ({item, approve}) => {
    dispatch(adminKiralikAracAprove({id: item?.id, isApproved:approve }))
  }

  return (
    <Container onClick={()=> {dispatch(setSelectRentalCar(data)); dispatch(showModal("adminRentalCarOptions")) }} theme={theme}>
      <div className="container">
        <div className="content">
          <div className="row">
            <div className="col">{moment(data?.createdAt).format('L')}</div>
            <div className="col">{data?.vehicleType}</div>
            <div className="col">{data?.bodyType || "-"}</div>
            <div className="col">{data?.truckVehicleWorkCities.$values.map((item, i) => {
              return `${item.city}${i+1 !== data?.truckVehicleWorkCities.$values.length ? ", " : ""}`
            })}</div>
            <div className="col">{data?.workRoute}</div>
            <div className="col">{data?.fuelPercentage}</div>
            <div className="col">{data?.rentalPrice}</div>
            <div className="col">{data?.contactNumber}</div>
            <div className="col">{data?.advertOwner}</div>
            <div className="col">{data?.advertiserPhoneNumber}</div>
            <div className="col">{moment(data?.advertEndDate).format('L')}</div>
            {data?.isApproved === 0 && <div onClick={(e) => e.stopPropagation()} className="col">
              <p onClick={() => handleAprove({item: data, approve: 1})}>Onayla</p>
              <p onClick={() => handleAprove({item: data, approve: 2})}>Reddet</p>
            </div> }
            {data?.isApproved === 1 && <div className="col">Onaylandı</div> }
            {data?.isApproved === 2 && <div className="col">Reddedildi</div> }
            
            <div className="col">{data?.isActive === true ? "Yayında" : "Arşivde"}</div>
            <div className="col">{data?.isVehicleRented === true ? "Evet" : "Hayır"}</div>
            
            {/* <div onClick={(e)=> {toggleMore(data); e.stopPropagation(e) }} className="more"><MdOutlineMoreHoriz/></div>
            {isMoreActive && 
              <div className="detail">
                <p className="delete">İlanı Sil</p> 
              </div> 
            } */}
          </div>
        </div>
      </div>
    </Container>
  );
};

export default AdminKiralikAracContainer;
